import { NgModule } from '@angular/core';
import { DashCasePipe } from './dash-case-pipe';

@NgModule({
  declarations: [
    DashCasePipe
  ],
  exports: [
    DashCasePipe
  ],
  imports: []
})
export class PipesModule { }

